import CacheManager from "./classes/CacheManager.js";

export const isIos = () => {
  // iPad on iOS 13 detection
  return navigator.userAgent.includes("Mac") && "ontouchend" in document;
};

/**
 *
 * @param {number} container
 * @param {number} from
 * @param {number} till
 * @param {number} speed
 * @returns {number}
 */
export function getDragOffset(container, from, till, speed) {
  const offset = ((from - till) / (0xff / speed)) * container;
  const rounded = Math.round(offset);

  return Math.sign(rounded);
}

/**
 *
 * @param {TouchList} points
 * @returns {number}
 */
export function getTouchDistance(points) {
  const offsetX = Math.abs(points[0].clientX - points[1].clientX);
  const offsetY = Math.abs(points[0].clientY - points[1].clientY);

  const powerX = Math.pow(offsetX, 2);
  const powerY = Math.pow(offsetY, 2);

  return Math.round(Math.sqrt(powerX + powerY));
}

/**
 *
 * @param {string} name
 * @param {object} classes
 * @returns {HTMLButtonElement}
 */
export function createButton(name, classes = []) {
  const btn = document.createElement("button");
  btn.classList.add(`${name}-button`, ...classes);
  btn.innerHTML = `<span class="material-symbols-rounded ${name}"></span>`;

  return btn;
}

export const CACHE_MANAGER = new CacheManager();
